export default __webpack_public_path__ + "static/tour_07_realtime_feedback-e8811bfec997843f1b02e0da5c40ae5f.jpg";